module.exports = __webpack_public_path__ + "img/ea48237.png";